import { createSelector } from 'reselect';
import { Map as ImmutableMap } from 'immutable';
import { basicSelector } from 'ContentEditorUI/redux/selectors/helpers';
import { SIMPLE_AUTOMATION_EMAIL_WORKFLOW_TRIGGERS } from 'ContentEditorUI/utils/automationConstants';
import { getAttribute } from 'ContentEditorUI/redux/selectors/userAttributesSelectors';
import { getIsAutomatedLike, getHasEverBeenPublished, getIsAutomatedForWorkflows
// @ts-expect-error no declarations found for module
} from 'EmailEditorUI/redux/selectors/EmailSelectors';
import { getHasFullEditorAccess } from 'EmailEditorUI/redux/selectors/AuthSelectors';
import { CURRENT_USER_ATTRIBUTES } from 'EmailEditorUI/constants/UserAttributesForEditor';
export const getEmailWorkflows = basicSelector(state => state.workflows.workflows);
export const getSimpleWorkflows = basicSelector(state => state.simpleWorkflows.simpleWorkflows);
export const getEnabledSimpleWorkflows = basicSelector(state => {
  return state.simpleWorkflows.simpleWorkflows.filter(swf => swf.isEnabled);
});
export const getEmailHasSimpleWorkflows = createSelector([getSimpleWorkflows], simpleWf => simpleWf.length > 0);
export const getHasEmailWorkflows = createSelector(getEmailWorkflows, emailWorkflows => Object.keys(emailWorkflows).length > 0);
export const getEmailWorkflowsAsMap = createSelector(getEmailWorkflows, emailWorkflows => {
  return ImmutableMap(Object.values(emailWorkflows).map(workflow => [workflow.id, ImmutableMap(workflow)]));
});
export const getSimpleWorkflowsAsMap = createSelector([getSimpleWorkflows], simpleWorkflows => {
  return simpleWorkflows.map(swf => ImmutableMap(Object.assign({}, swf, {
    sourceApp: swf.createdSourceApp
  })));
});
export const getSimpleWorkflowsAsIdMap = createSelector([getSimpleWorkflows], simpleWorkflows => {
  return ImmutableMap(simpleWorkflows.map(swf => [swf.flowId, ImmutableMap(swf)]));
});
export const getUsedWorkflowTriggers = createSelector([getSimpleWorkflows], workflows => {
  return workflows.reduce((acc, next) => {
    const type = next.uuid.split('-')[2];
    if (!acc.includes(type)) {
      acc.push(type);
    }
    return acc;
  }, []);
});
export const getTriggersUsedMoreThanOnce = createSelector([getSimpleWorkflows, getHasFullEditorAccess], (simpleWorkflows, hasFullEditorAccess) => {
  let triggersToBeDisabled = ImmutableMap([]);
  simpleWorkflows.reduce((acc, next) => {
    const type = next.uuid.split('-')[2];
    if (acc.includes(type)) {
      triggersToBeDisabled = triggersToBeDisabled.set(type, !hasFullEditorAccess);
    }
    acc.push(type);
    return acc;
  }, []);
  return triggersToBeDisabled;
});
export const getIsUsingSameTriggerTwice = createSelector([getTriggersUsedMoreThanOnce], triggers => {
  return !triggers.isEmpty();
});
export const getSimpleWorkflowTriggers = createSelector([getUsedWorkflowTriggers, getHasFullEditorAccess], (usedTriggers, hasFullEditorAccess) => {
  return SIMPLE_AUTOMATION_EMAIL_WORKFLOW_TRIGGERS.map(trigger => ({
    trigger,
    disabled: !hasFullEditorAccess && usedTriggers.includes(trigger)
  }));
});
export const getAvailableSimpleWorkflowTrigger = createSelector([getUsedWorkflowTriggers, getHasFullEditorAccess], (usedTriggers, hasFullEditorAccess) => {
  return SIMPLE_AUTOMATION_EMAIL_WORKFLOW_TRIGGERS.filter(trigger => hasFullEditorAccess || !usedTriggers.includes(trigger));
});
export const getIsWorkflowsLoading = basicSelector(state => state.workflows.isLoading);
export const getIsSimpleWorkflowsLoading = basicSelector(state => state.simpleWorkflows.isLoading);
export const getWorkflowsHasError = basicSelector(state => state.workflows.hasError);
export const getWorkflowsIsBeenFetched = basicSelector(state => state.workflows.isBeenFetched);
export const getShouldFetchEmailWorkflows = createSelector([getIsAutomatedLike, getHasEverBeenPublished, getWorkflowsIsBeenFetched, getWorkflowsHasError], (isAutomatedLike, hasEverBeenPublished, isBeenFetched, hasError) => isAutomatedLike && hasEverBeenPublished && (!isBeenFetched || hasError));
export const getInteractionsWithContextualAutomation = basicSelector(state => {
  const isAutomatedForWorkflows = getIsAutomatedForWorkflows(state);
  const attrKey = isAutomatedForWorkflows ? CURRENT_USER_ATTRIBUTES.HAS_INTERACTED_WITH_EMAIL_CONTEXTUAL_AUTOMATION : CURRENT_USER_ATTRIBUTES.HAS_INTERACTED_WITH_REGULAR_EMAIL_AUTOMATION;
  return parseInt(getAttribute(state, attrKey) || '0', 10);
});